import { fetchValuation } from './api/fetchValuation';
import { hasKeys, prepareFetchValuationArguments } from './utils';

export const fetchFormattedValuation = async (
  widgetFormData: Record<string, unknown>,
): Promise<string | null> => {
  if (shouldNotRequest(widgetFormData)) return null;

  const valuationResponse = await fetchValuation(prepareFetchValuationArguments(widgetFormData));

  return valuationResponse;
};

function shouldNotRequest(widgetFormData: Record<string, unknown>): boolean {
  // ! sessionID needs to be added to the array once it is implemented in the core
  const requiredArgs = ['livingSpaceSize', 'property', 'zipCode'];
  const supportedPropertyValues = ['Kauf_Haus', 'Kauf_Wohnung'];
  const supportedPropertyTypes = ['Mehrfamilienhaus', 'WOHN- UND GESCHÄFTSGEBÄUDE'];
  const propertyIsSupported = supportedPropertyValues.includes(widgetFormData.property as string);
  const propertyTypeIsSupported = supportedPropertyTypes.includes(
    widgetFormData.propertyType as string,
  );

  return !hasKeys(widgetFormData, requiredArgs) || !propertyIsSupported || !propertyTypeIsSupported;
}
